import { Container } from '@mui/material';
import HomeCategories from './HomeCategories';
import HomeHeader from './HomeHeader';

const Home = (): JSX.Element => (
  <Container>
    <HomeHeader />

    <HomeCategories />
  </Container>
);

export default Home;